<template>
  <VueSlickCarousel v-bind="settings" @lazyLoad="lazyLoad" ref="slider">
    <slot></slot>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
export default {
  props: ['slidesToShow', 'slidesToShowMobile', 'slidesToShowMedium', 'slidesToScroll', 'showDotsMobile'],
  components: {
    VueSlickCarousel
  },

  data() {
    return {
      settings: {
        autoplay: false,
        slidesToShow: this.slidesToShow ?? 3,
        slidesToScroll: this.slidesToScroll ?? 1,
        dots: true,
        arrows: true,
        infinite: false,
        waitForAnimate: false,
        swipeToSlide: true,
        draggable: false,
        //lazyLoad: 'progressive',
        touchThreshold: 10,
        speed: 500,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: this.slidesToShowMedium ?? 2.1,
              slidesToScroll: this.slidesToShowMedium ?? 1,
              dots: false,
              arrows: true,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.1,
              slidesToScroll: 1.5,
              dots: this.showDotsMobile,
              arrows: true,
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: this.slidesToShowMobile ?? 1.1,
              slidesToScroll: 1,
              dots: this.showDotsMobile,
              arrows: true,
              speed: 300,
            }
          },
          {
            breakpoint: 340,
            settings: {
              slidesToShow: .95,
              slidesToScroll: 1,
              dots: this.showDotsMobile,
              arrows: false,
            }
          },
        ]
      }
    }
  },

  methods: {
    lazyLoad() {
      this.$nextTick(() => {
        if(this.$refs.slider) {
          var images = this.$refs.slider.$el.querySelectorAll('img[data-src]:not([src])');
          images.forEach(img => window.imgLazyload(img));
        };
      });
    }
  }
}
</script>
